(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var timers = document.querySelectorAll('[data-countdown-target]');
    timers.forEach(function (timer) {
      var rawTarget = timer.getAttribute('data-countdown-target');
      // Normalize: split on 'T' so both "May 31, 2026T00:00:00" and "2026-05-31T00:00:00" work
      var targetParts = rawTarget.split('T');
      var targetDate = targetParts[0].trim();
      var targetTime = targetParts.length > 1 ? targetParts[1].trim() : '00:00:00';
      var target = new Date(targetDate + ' ' + targetTime).getTime();
      var daysEl = timer.querySelector('[data-countdown-days]');
      var hoursEl = timer.querySelector('[data-countdown-hours]');
      var minutesEl = timer.querySelector('[data-countdown-minutes]');
      var secondsEl = timer.querySelector('[data-countdown-seconds]');

      function pad(n) {
        return n < 10 ? '0' + n : n;
      }

      function update() {
        var now = new Date().getTime();
        var diff = target - now;

        if (diff <= 0) {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          return;
        }

        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((diff % (1000 * 60)) / 1000);

        daysEl.textContent = pad(days);
        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);
      }

      update();
      setInterval(update, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
  class InstagramCarousel extends HTMLElement {
    connectedCallback() {
      this.current = 0;
      this.cards = [];
      this.posts = [];
      this.loaded = false;
      this.isVisible = false;
      this.autoInterval = null;

      this.track = this.querySelector('[data-track]');
      this.dotsContainer = this.querySelector('[data-dots]');
      this.prevBtn = this.querySelector('[data-arrow-prev]');
      this.nextBtn = this.querySelector('[data-arrow-next]');
      this.feedUrl = this.dataset.feedUrl;

      if (!this.feedUrl) return;

      this._onIntersect = this._onIntersect.bind(this);
      this._onMouseEnter = this._stopAutoRotate.bind(this);
      this._onMouseLeave = () => {
        if (this.isVisible) this._startAutoRotate();
      };
      this._onPrevClick = () => this._goTo(this.current - 1);
      this._onNextClick = () => this._goTo(this.current + 1);

      if (this.prevBtn) this.prevBtn.addEventListener('click', this._onPrevClick);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this._onNextClick);

      // Swipe state
      this._startX = 0;
      this._startY = 0;
      this._swiping = false;
      this._swipeLocked = false;
      this._onTouchStart = this._onTouchStart.bind(this);
      this._onTouchMove = this._onTouchMove.bind(this);
      this._onTouchEnd = this._onTouchEnd.bind(this);

      this.observer = new IntersectionObserver(this._onIntersect, { rootMargin: '200px' });
      this.observer.observe(this);

      this.addEventListener('mouseenter', this._onMouseEnter);
      this.addEventListener('mouseleave', this._onMouseLeave);
    }

    disconnectedCallback() {
      this._stopAutoRotate();
      this._pauseAllVideos();

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      this.removeEventListener('mouseenter', this._onMouseEnter);
      this.removeEventListener('mouseleave', this._onMouseLeave);

      if (this.prevBtn) this.prevBtn.removeEventListener('click', this._onPrevClick);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this._onNextClick);

      if (this.track) {
        this.track.removeEventListener('touchstart', this._onTouchStart);
        this.track.removeEventListener('touchmove', this._onTouchMove);
        this.track.removeEventListener('touchend', this._onTouchEnd);
      }
    }

    _onIntersect(entries) {
      entries.forEach((entry) => {
        this.isVisible = entry.isIntersecting;
        if (this.isVisible && !this.loaded) {
          this.loaded = true;
          this._loadFeed();
        }
        if (this.isVisible) {
          this._startAutoRotate();
          this._playCurrentVideo();
        } else {
          this._stopAutoRotate();
          this._pauseAllVideos();
        }
      });
    }

    _loadFeed() {
      this.track.innerHTML = '<div class="instagram-feed__loading">Loading...</div>';

      let accentColor = '#5ac3ab';
      const btnEl = this.querySelector('.instagram-feed__btn');
      if (btnEl) {
        try {
          accentColor = getComputedStyle(btnEl).backgroundColor;
        } catch (e) {}
      }

      fetch(this.feedUrl)
        .then((res) => res.json())
        .then(async (data) => {
          this.posts = data.posts || [];
          if (!this.posts.length) {
            this.track.innerHTML = '';
            return;
          }

          // Behold 502s any image it has not managed to cache from Instagram, and a
          // <video> whose poster fails renders as a blank rectangle with no error event
          // to hook. So probe each poster up front and keep only the posts that actually
          // have an image. Self-healing: once Behold's connection is fixed the missing
          // posts come back on their own with no code change.
          const posterFor = (p) =>
            (p.sizes && p.sizes.large ? p.sizes.large.mediaUrl : '') || p.thumbnailUrl || '';
          const loads = (url) =>
            new Promise((resolve) => {
              if (!url) {
                resolve(false);
                return;
              }
              const probe = new Image();
              probe.onload = () => resolve(true);
              probe.onerror = () => resolve(false);
              probe.src = url;
            });

          const okFlags = await Promise.all(this.posts.map((p) => loads(posterFor(p))));
          const usable = this.posts.filter((p, i) => okFlags[i]);

          if (!usable.length) {
            // Nothing renderable at all — hide the whole section rather than leave an
            // empty strip and a heading with nothing under it.
            this.track.innerHTML = '';
            const host = this.closest('.shopify-section');
            if (host) host.style.display = 'none';
            return;
          }

          this.posts = usable;

          this.track.innerHTML = '';

          this.cards = this.posts.map((post, i) => {
            const card = document.createElement('a');
            card.href = post.permalink;
            card.target = '_blank';
            card.rel = 'noopener noreferrer';
            card.className = 'instagram-feed__card';

            const isVideo = post.mediaType === 'VIDEO';
            const altText = (post.prunedCaption || '').replace(/"/g, '&quot;').substring(0, 100);

            let mediaHtml;
            if (isVideo) {
              const posterSrc = (post.sizes && post.sizes.large ? post.sizes.large.mediaUrl : '') || post.thumbnailUrl || '';  // Behold's cached copy first: Instagram's thumbnailUrl is a signed URL that 403s after a few days, and because it is always PRESENT the old fallback never fired. Matches the image path below.
              mediaHtml =
                '<video src="' +
                post.mediaUrl +
                '" muted loop playsinline preload="none"' +
                (posterSrc ? ' poster="' + posterSrc + '"' : '') +
                '></video>';
            } else {
              const imgSrc = post.sizes && post.sizes.large ? post.sizes.large.mediaUrl : post.mediaUrl;
              mediaHtml = '<img src="' + imgSrc + '" alt="' + altText + '" loading="lazy">';
            }

            card.innerHTML =
              mediaHtml +
              '<div class="instagram-feed__gradient"></div>' +
              (isVideo
                ? '<div class="instagram-feed__play"><svg width="22" height="26" viewBox="0 0 22 26" fill="none"><polygon points="2,1 20,13 2,25" fill="#333"/></svg></div>'
                : '') +
              '<div class="instagram-feed__likes">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="white"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>' +
              '<span>' +
              InstagramCarousel.formatCount(post.likeCount) +
              '</span>' +
              '</div>';

            card.addEventListener('click', (e) => {
              const len = this.posts.length;
              let offset = (((i - this.current) % len) + len) % len;
              if (offset > Math.floor(len / 2)) offset -= len;
              if (offset !== 0) {
                e.preventDefault();
                this._goTo(this.current + offset);
              }
            });

            this.track.appendChild(card);
            return card;
          });

          // Build dots
          this.dotsContainer.innerHTML = '';
          this.posts.forEach((_, i) => {
            const dot = document.createElement('button');
            dot.className = 'instagram-feed__dot';
            dot.style.backgroundColor = accentColor;
            dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            dot.addEventListener('click', () => this._goTo(i));
            this.dotsContainer.appendChild(dot);
          });

          // Swipe
          this.track.addEventListener('touchstart', this._onTouchStart, { passive: true });
          this.track.addEventListener('touchmove', this._onTouchMove, { passive: false });
          this.track.addEventListener('touchend', this._onTouchEnd);

          this._layout();
          if (this.isVisible) this._startAutoRotate();
        })
        .catch((err) => {
          console.error('Instagram feed error:', err);
          this.track.innerHTML = '';
        });
    }

    _goTo(index) {
      if (!this.posts.length) return;
      const len = this.posts.length;
      this.current = ((index % len) + len) % len;
      this._layout();
    }

    _layout() {
      const len = this.posts.length;
      const posClasses = {
        0: 'instagram-feed__card--center',
        '-1': 'instagram-feed__card--left-1',
        1: 'instagram-feed__card--right-1',
        '-2': 'instagram-feed__card--left-2',
        2: 'instagram-feed__card--right-2',
      };

      this.cards.forEach((card, i) => {
        card.className = 'instagram-feed__card';
        let offset = (((i - this.current) % len) + len) % len;
        if (offset > Math.floor(len / 2)) offset -= len;

        const cls = posClasses[offset];
        if (cls) {
          card.classList.add(cls);
        } else {
          card.classList.add(offset < 0 ? 'instagram-feed__card--hidden-left' : 'instagram-feed__card--hidden-right');
        }
      });

      const dots = this.dotsContainer.querySelectorAll('.instagram-feed__dot');
      dots.forEach((dot, i) => {
        dot.classList.toggle('instagram-feed__dot--active', i === this.current);
      });

      if (this.isVisible) this._playCurrentVideo();
    }

    _playCurrentVideo() {
      this.cards.forEach((card, i) => {
        const video = card.querySelector('video');
        if (!video) return;
        if (i === this.current && this.isVisible) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }

    _pauseAllVideos() {
      this.cards.forEach((card) => {
        const video = card.querySelector('video');
        if (video) video.pause();
      });
    }

    _startAutoRotate() {
      this._stopAutoRotate();
      this.autoInterval = setInterval(() => this._goTo(this.current + 1), 5000);
    }

    _stopAutoRotate() {
      if (this.autoInterval) {
        clearInterval(this.autoInterval);
        this.autoInterval = null;
      }
    }

    // Swipe handlers
    _onTouchStart(e) {
      this._startX = e.touches[0].clientX;
      this._startY = e.touches[0].clientY;
      this._swiping = true;
      this._swipeLocked = false;
    }

    _onTouchMove(e) {
      if (!this._swiping) return;
      const dx = Math.abs(e.touches[0].clientX - this._startX);
      const dy = Math.abs(e.touches[0].clientY - this._startY);
      if (!this._swipeLocked) {
        if (dx > 8 || dy > 8) {
          this._swipeLocked = true;
          if (dx > dy) {
            e.preventDefault();
          } else {
            this._swiping = false;
          }
        }
      } else if (dx > dy) {
        e.preventDefault();
      }
    }

    _onTouchEnd(e) {
      if (!this._swiping) return;
      this._swiping = false;
      const diff = e.changedTouches[0].clientX - this._startX;
      if (Math.abs(diff) > 40) {
        this._goTo(diff > 0 ? this.current - 1 : this.current + 1);
      }
    }

    static formatCount(n) {
      if (!n) return '0';
      if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
      return n.toString();
    }
  }

  if (!customElements.get('instagram-carousel')) {
    customElements.define('instagram-carousel', InstagramCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-other-products"] && !Shopify.designMode) return;
  try {
    
  class ShopOtherProducts extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;

      this.slides = Array.from(this.querySelectorAll('[data-sop-slide]'));
      this.titles = Array.from(this.querySelectorAll('[data-sop-title-item]'));
      this.prevBtn = this.querySelector('[data-sop-prev]');
      this.nextBtn = this.querySelector('[data-sop-next]');
      if (!this.slides.length) return;

      this.current = this.slides.length >= 2 ? 1 : 0;

      this._onSlideClick = this._onSlideClick.bind(this);
      this._onPrev = () => this._goTo(this.current - 1);
      this._onNext = () => this._goTo(this.current + 1);
      this._onTouchStart = this._onTouchStart.bind(this);
      this._onTouchMove = this._onTouchMove.bind(this);
      this._onTouchEnd = this._onTouchEnd.bind(this);

      this.slides.forEach((slide) => slide.addEventListener('click', this._onSlideClick));
      if (this.prevBtn) this.prevBtn.addEventListener('click', this._onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this._onNext);
      this.track.addEventListener('touchstart', this._onTouchStart, { passive: true });
      this.track.addEventListener('touchmove', this._onTouchMove, { passive: false });
      this.track.addEventListener('touchend', this._onTouchEnd);

      this._layout();
    }

    disconnectedCallback() {
      this.slides.forEach((slide) => slide.removeEventListener('click', this._onSlideClick));
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this._onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this._onNext);
      if (this.track) {
        this.track.removeEventListener('touchstart', this._onTouchStart);
        this.track.removeEventListener('touchmove', this._onTouchMove);
        this.track.removeEventListener('touchend', this._onTouchEnd);
      }
    }

    _goTo(index) {
      const len = this.slides.length;
      this.current = ((index % len) + len) % len;
      this._layout();
    }

    _layout() {
      const len = this.slides.length;
      const posClasses = {
        0: 'sop-slide--center',
        '-1': 'sop-slide--left',
        1: 'sop-slide--right',
      };

      this.slides.forEach((slide, i) => {
        slide.className = 'sop-slide';
        let offset = (((i - this.current) % len) + len) % len;
        if (offset > Math.floor(len / 2)) offset -= len;

        const cls = posClasses[offset];
        if (cls) {
          slide.classList.add(cls);
        } else {
          slide.classList.add(offset < 0 ? 'sop-slide--hidden-left' : 'sop-slide--hidden-right');
        }
      });

      this.titles.forEach((title, i) => {
        title.style.display = i === this.current ? '' : 'none';
      });
    }

    _onSlideClick(e) {
      const slide = e.currentTarget;
      const index = this.slides.indexOf(slide);
      if (index === -1) return;
      const len = this.slides.length;
      let offset = (((index - this.current) % len) + len) % len;
      if (offset > Math.floor(len / 2)) offset -= len;
      if (offset === 0) return;
      e.preventDefault();
      this._goTo(this.current + offset);
    }

    _onTouchStart(e) {
      this._startX = e.touches[0].clientX;
      this._startY = e.touches[0].clientY;
      this._swiping = true;
      this._swipeLocked = false;
    }

    _onTouchMove(e) {
      if (!this._swiping) return;
      const dx = Math.abs(e.touches[0].clientX - this._startX);
      const dy = Math.abs(e.touches[0].clientY - this._startY);
      if (!this._swipeLocked) {
        if (dx > 8 || dy > 8) {
          this._swipeLocked = true;
          if (dx > dy) {
            e.preventDefault();
          } else {
            this._swiping = false;
          }
        }
      } else if (dx > dy) {
        e.preventDefault();
      }
    }

    _onTouchEnd(e) {
      if (!this._swiping) return;
      this._swiping = false;
      const diff = e.changedTouches[0].clientX - this._startX;
      if (Math.abs(diff) > 40) {
        this._goTo(diff > 0 ? this.current - 1 : this.current + 1);
      }
    }
  }

  if (!customElements.get('shop-other-carousel')) {
    customElements.define('shop-other-carousel', ShopOtherProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wigglitz-reels"] && !Shopify.designMode) return;
  try {
    
  /* Wigglitz Reels — see the comment block at the top of the section file for
     WHY any of this exists. Shopify bundles this once per section TYPE, so
     module scope is shared by every instance on the page. */

  var WREELS_RESUME_MS = 1200; // how long after a touch/drag/focus before gliding resumes
  var WREELS_DRAG_SLOP = 6; // px of mouse travel that turns a click into a drag
  var WREELS_MAX_CARDS = 48; // hard ceiling on cloned cards, see _buildStrip

  class WigglitzReels extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-wreels-track]');
      if (!this.track) return;

      this.originals = Array.prototype.slice.call(this.track.children);
      if (!this.originals.length) return;

      this.speed = parseFloat(this.dataset.speed) || 0;
      this.reverse = this.dataset.direction === 'right';
      this.pauseOnHover = this.dataset.pauseOnHover !== 'false';
      this.wantsAuto = this.dataset.autoscroll === 'true' && this.speed > 0 && this.originals.length > 1;

      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      // Holds are the single source of truth for "should the strip be moving".
      // Anything that wants it stopped adds a reason; the loop runs only when
      // the set is empty. Starts held because the section is assumed off-screen
      // until the IntersectionObserver says otherwise.
      this._holds = new Set(['offscreen']);

      this._pos = 0;
      this._applied = 0;
      this._wrapDistance = 0;
      this._rafId = null;
      this._lastTs = 0;
      this._drag = null;
      this._suppressClick = false;
      this._syncQueued = false;
      this._resumeTimers = {}; // one per hold reason — see _scheduleResume
      this._resizeTimer = null;
      this._lastWidth = 0;

      this._tick = this._tick.bind(this);
      this._onCardIntersect = this._onCardIntersect.bind(this);
      this._onHostIntersect = this._onHostIntersect.bind(this);
      this._onPointerDown = this._onPointerDown.bind(this);
      this._onPointerMove = this._onPointerMove.bind(this);
      this._onPointerUp = this._onPointerUp.bind(this);
      this._onClickCapture = this._onClickCapture.bind(this);
      this._onWheel = this._onWheel.bind(this);
      this._onTouchMove = this._onTouchMove.bind(this);
      this._onKeyDown = this._onKeyDown.bind(this);
      this._onFocusIn = this._onFocusIn.bind(this);
      this._onFocusOut = this._onFocusOut.bind(this);
      this._onMouseEnter = this._onMouseEnter.bind(this);
      this._onMouseLeave = this._onMouseLeave.bind(this);
      this._onToggle = this._onToggle.bind(this);
      this._onVisibility = this._onVisibility.bind(this);
      this._onResize = this._onResize.bind(this);
      this._onMotionChange = this._onMotionChange.bind(this);
      this._onMediaPlaying = this._onMediaPlaying.bind(this);
      this._onMediaStopped = this._onMediaStopped.bind(this);
      this._onBlockSelect = this._onBlockSelect.bind(this);
      this._onBlockDeselect = this._onBlockDeselect.bind(this);

      this._refreshCapabilities();

      this.toggleBtn = this.querySelector('[data-wreels-toggle]');
      this.toggleLabel = this.querySelector('[data-wreels-toggle-label]');
      if (this.toggleBtn) {
        this.toggleBtn.hidden = !this.canAuto;
        this.toggleBtn.addEventListener('click', this._onToggle);
      }

      // Two observers with different jobs. The host one only decides whether
      // the rAF loop is allowed to burn frames at all. The card one decides
      // which individual clips get a src and which get to play — its horizontal
      // rootMargin is bigger than the vertical one because cards enter and
      // leave sideways, fast.
      if (typeof IntersectionObserver !== 'undefined') {
        this._hostObserver = new IntersectionObserver(this._onHostIntersect, { rootMargin: '100px' });
        this._hostObserver.observe(this);
        this._cardObserver = new IntersectionObserver(this._onCardIntersect, {
          rootMargin: '200px 400px',
          threshold: [0, 0.6],
        });
      } else {
        // No IO (very old browser): never hydrate video, leave the posters.
        this._release('offscreen');
      }

      this.track.addEventListener('pointerdown', this._onPointerDown);
      this.track.addEventListener('pointermove', this._onPointerMove);
      this.track.addEventListener('pointerup', this._onPointerUp);
      this.track.addEventListener('pointercancel', this._onPointerUp);
      this.track.addEventListener('touchstart', this._onPointerDown, { passive: true });
      this.track.addEventListener('touchmove', this._onTouchMove, { passive: true });
      this.track.addEventListener('touchend', this._onPointerUp, { passive: true });
      this.track.addEventListener('keydown', this._onKeyDown);
      this.track.addEventListener('wheel', this._onWheel, { passive: true });
      this.track.addEventListener('click', this._onClickCapture, true);
      this.track.addEventListener('focusin', this._onFocusIn);
      this.track.addEventListener('focusout', this._onFocusOut);
      // Media events do not bubble — capture on the track instead of wiring a
      // listener pair onto every <video> (and every clone).
      this.track.addEventListener('playing', this._onMediaPlaying, true);
      this.track.addEventListener('pause', this._onMediaStopped, true);
      this.track.addEventListener('emptied', this._onMediaStopped, true);

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', this._onMouseEnter);
        this.addEventListener('mouseleave', this._onMouseLeave);
      }

      document.addEventListener('visibilitychange', this._onVisibility);
      window.addEventListener('resize', this._onResize, { passive: true });
      window.addEventListener('orientationchange', this._onResize, { passive: true });
      document.addEventListener('shopify:block:select', this._onBlockSelect);
      document.addEventListener('shopify:block:deselect', this._onBlockDeselect);

      if (this.motionQuery.addEventListener) {
        this.motionQuery.addEventListener('change', this._onMotionChange);
      } else if (this.motionQuery.addListener) {
        this.motionQuery.addListener(this._onMotionChange); // Safari < 14
      }

      // Wait one frame so the cards have a laid-out width before we measure the
      // repeat period.
      requestAnimationFrame(() => this._buildStrip());
    }

    disconnectedCallback() {
      this._stopLoop();
      this._teardownAllVideos();

      if (this._hostObserver) this._hostObserver.disconnect();
      if (this._cardObserver) this._cardObserver.disconnect();
      this._hostObserver = null;
      this._cardObserver = null;

      this._clearResumeTimers();
      clearTimeout(this._resizeTimer);

      if (this.track) {
        this.track.removeEventListener('pointerdown', this._onPointerDown);
        this.track.removeEventListener('pointermove', this._onPointerMove);
        this.track.removeEventListener('pointerup', this._onPointerUp);
        this.track.removeEventListener('pointercancel', this._onPointerUp);
        this.track.removeEventListener('touchstart', this._onPointerDown);
        this.track.removeEventListener('touchmove', this._onTouchMove);
        this.track.removeEventListener('touchend', this._onPointerUp);
        this.track.removeEventListener('keydown', this._onKeyDown);
        this.track.removeEventListener('wheel', this._onWheel);
        this.track.removeEventListener('click', this._onClickCapture, true);
        this.track.removeEventListener('focusin', this._onFocusIn);
        this.track.removeEventListener('focusout', this._onFocusOut);
        this.track.removeEventListener('playing', this._onMediaPlaying, true);
        this.track.removeEventListener('pause', this._onMediaStopped, true);
        this.track.removeEventListener('emptied', this._onMediaStopped, true);
      }

      if (this.toggleBtn) this.toggleBtn.removeEventListener('click', this._onToggle);
      this.removeEventListener('mouseenter', this._onMouseEnter);
      this.removeEventListener('mouseleave', this._onMouseLeave);
      document.removeEventListener('visibilitychange', this._onVisibility);
      window.removeEventListener('resize', this._onResize);
      window.removeEventListener('orientationchange', this._onResize);
      document.removeEventListener('shopify:block:select', this._onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this._onBlockDeselect);

      if (this.motionQuery) {
        if (this.motionQuery.removeEventListener) {
          this.motionQuery.removeEventListener('change', this._onMotionChange);
        } else if (this.motionQuery.removeListener) {
          this.motionQuery.removeListener(this._onMotionChange);
        }
      }
    }

    /* ------------------------------------------------------------------ */
    /* Capabilities                                                        */
    /* ------------------------------------------------------------------ */

    _refreshCapabilities() {
      var reduced = this.motionQuery.matches;
      this.allowPlayback = !reduced;
      this.canAuto = this.wantsAuto && !reduced;
      // iOS Safari will only decode a small number of videos at once and starts
      // silently refusing play() past that; the cap is a correctness fix as much
      // as a bandwidth one. Phones get 2 because at ~200px cards that is already
      // more than a screenful.
      this._maxPlaying = window.innerWidth < 768 ? 2 : 4;
    }

    _onMotionChange() {
      this._refreshCapabilities();
      if (this.toggleBtn) this.toggleBtn.hidden = !this.canAuto;
      if (!this.canAuto) this._stopLoop();
      if (!this.allowPlayback) this._teardownAllVideos();
      this._buildStrip();
    }

    /* ------------------------------------------------------------------ */
    /* Strip construction + the wrap period                                */
    /* ------------------------------------------------------------------ */

    _cards() {
      return Array.prototype.slice.call(this.track.children);
    }

    _buildStrip() {
      if (!this.isConnected || !this.track) return;

      this._stopLoop();
      this._teardownAllVideos();

      // Full disconnect, not per-element unobserve: observe() on a target that
      // is already observed is a no-op, so the surviving originals would never
      // get a fresh initial callback after a rebuild and their clips would stay
      // dead until they happened to cross a threshold again.
      if (this._cardObserver) this._cardObserver.disconnect();

      var clones = this.track.querySelectorAll('[data-wreels-clone]');
      for (var i = 0; i < clones.length; i++) clones[i].remove();

      this._wrapDistance = 0;
      this.track.classList.remove('is-auto');
      this.track.classList.remove('is-static');

      if (this.canAuto) this._cloneForWrap();

      // Nothing overflows (one reel, or auto-scroll switched off with only a
      // couple of reels on a wide screen): centre the strip instead of leaving
      // it hard left with a lake of empty space. Safe to centre only because we
      // have just confirmed there is nothing to scroll — justify-content: center
      // on an overflowing flex row makes the left-hand cards unreachable.
      this.track.classList.toggle('is-static', this.track.scrollWidth <= this.track.clientWidth + 1);

      this._observeCards();
      this._queueSync();
      this._maybeStart();
    }

    // Seamless wrap, the native-scroller way: lay out 2k identical passes of the
    // block list and jump scrollLeft back by k passes whenever it crosses that
    // line. k is chosen so ONE jump distance is at least a viewport wide —
    // otherwise the pixels either side of the jump are not the same pixels and
    // the seam shows.
    _cloneForWrap() {
      var originals = this.originals;
      if (originals.length < 2) return; // 1 reel: no cloning, no wrap maths to get wrong

      var first = originals[0];
      var last = originals[originals.length - 1];
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      // The repeat period is where the NEXT pass's first card would start, which
      // is the last card's right edge plus one gap. Measuring it this way stays
      // correct even if a card ever ends up a different width.
      var unit = last.offsetLeft + last.offsetWidth + gap - first.offsetLeft;
      var view = this.track.clientWidth;
      if (!unit || !view) return;

      var k = Math.max(1, Math.ceil(view / unit));
      var passes = 2 * k;
      // Bites on an ultrawide desktop with only one or two reels, where k grows
      // to cover the viewport. Falling back to a plain finite strip (no wrap, so
      // no glide) is the right failure: better a static strip than 90 video
      // elements. 12 reels on a normal desktop is k=1, i.e. 24 cards.
      if (passes * originals.length > WREELS_MAX_CARDS) return;

      var frag = document.createDocumentFragment();
      for (var p = 1; p < passes; p++) {
        for (var i = 0; i < originals.length; i++) {
          var clone = originals[i].cloneNode(true);
          clone.setAttribute('data-wreels-clone', '');
          // The clones are the same reels again. Hide them from assistive tech
          // and from the tab order so the strip is announced once, not 2k times.
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('tabindex', '-1');
          clone.removeAttribute('id');
          clone.removeAttribute('data-shopify-editor-block');
          frag.appendChild(clone);
        }
      }
      this.track.appendChild(frag);

      this._wrapDistance = k * unit;
      // Reverse gliding decrements scrollLeft, and scrollLeft cannot go below 0,
      // so start one wrap distance in and let it walk back down to zero.
      this._pos = this.reverse ? this._wrapDistance : 0;
      this.track.scrollLeft = this._pos;
      this._applied = this.track.scrollLeft;
    }

    _onResize() {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => {
        this._refreshCapabilities();
        // Height-only changes (a phone hiding its URL bar on scroll) fire resize
        // constantly and must NOT rebuild — that would tear down playing clips
        // and jump the scroll position mid-glide. Only width moves the maths.
        if (this.track.clientWidth === this._lastWidth) return;
        this._buildStrip();
      }, 200);
    }

    /* ------------------------------------------------------------------ */
    /* The rAF loop                                                        */
    /* ------------------------------------------------------------------ */

    _hold(reason) {
      this._holds.add(reason);
      this._stopLoop();
    }

    _release(reason) {
      this._holds.delete(reason);
      this._maybeStart();
    }

    _maybeStart() {
      if (!this.canAuto) return;
      if (this._holds.size > 0) return;
      if (this._wrapDistance <= 0) return; // nothing to wrap around: do not spin
      if (this._rafId !== null) return;
      this._lastTs = 0;
      this.track.classList.add('is-auto');
      this._rafId = requestAnimationFrame(this._tick);
    }

    _stopLoop() {
      if (this._rafId !== null) {
        cancelAnimationFrame(this._rafId);
        this._rafId = null;
      }
      // Deliberately does NOT re-enable scroll-snap. Turning snap ON makes the
      // browser re-snap immediately, so doing it here would jolt the strip the
      // instant a mouse merely hovered over it (hover pauses the loop). Snap
      // comes back in _handOverToUser, i.e. once the strip is already moving
      // under the user's finger, where a re-snap cannot be seen. Turning snap
      // OFF never moves anything, so _maybeStart can do that whenever it likes.
    }

    _handOverToUser() {
      this.track.classList.remove('is-auto');
    }

    _tick(ts) {
      this._rafId = null;
      if (!this.canAuto || this._holds.size > 0 || this._wrapDistance <= 0) return;

      var dt = this._lastTs ? ts - this._lastTs : 16;
      this._lastTs = ts;
      // A backgrounded tab or a long main-thread stall would otherwise hand us a
      // multi-second delta and teleport the strip.
      if (dt > 50) dt = 50;

      var track = this.track;
      // Anything else that moved the scroller — a snap settling, the browser
      // scrolling a focused link into view, the theme editor — wins. Resync
      // rather than fight it.
      if (Math.abs(track.scrollLeft - this._applied) > 2) this._pos = track.scrollLeft;

      this._pos += (this.reverse ? -1 : 1) * this.speed * (dt / 1000);

      if (this._pos >= this._wrapDistance) this._pos -= this._wrapDistance;
      else if (this._pos < 0) this._pos += this._wrapDistance;

      track.scrollLeft = this._pos;
      // Read back what the browser actually stored (it may round) so next
      // frame's "did someone else move this?" check compares like with like.
      this._applied = track.scrollLeft;

      this._rafId = requestAnimationFrame(this._tick);
    }

    /* ------------------------------------------------------------------ */
    /* Interaction                                                         */
    /* ------------------------------------------------------------------ */

    _onHostIntersect(entries) {
      var entry = entries[entries.length - 1];
      if (!entry.isIntersecting) {
        this._hold('offscreen');
        return;
      }
      // Built while the section had no width (hidden tab, collapsed parent)?
      // Nothing could be measured then, so there is no wrap and no glide. Now
      // that it is on screen, measure again.
      if (this.canAuto && this._wrapDistance === 0 && this.track.clientWidth > 0) {
        this._buildStrip();
      }
      this._release('offscreen');
    }

    _onVisibility() {
      if (document.hidden) this._hold('hidden');
      else this._release('hidden');
    }

    _onMouseEnter() {
      this._hold('hover');
    }

    _onMouseLeave() {
      this._release('hover');
    }

    _onFocusIn() {
      this._hold('focus');
    }

    _onFocusOut() {
      this._scheduleResume('focus');
    }

    _onWheel() {
      this._hold('pointer');
      this._handOverToUser();
      this._scheduleResume('pointer');
    }

    _onTouchMove() {
      this._handOverToUser();
    }

    // Arrow keys / Home / End on the focused scroller are pure browser
    // behaviour; we only step out of the way and let snap help them land.
    _onKeyDown() {
      this._hold('focus');
      this._handOverToUser();
    }

    // One timer PER REASON. A single shared timer meant a focusout could clear
    // the pointer timer and leave the strip permanently held.
    _scheduleResume(reason) {
      clearTimeout(this._resumeTimers[reason]);
      this._resumeTimers[reason] = setTimeout(() => this._release(reason), WREELS_RESUME_MS);
    }

    _clearResumeTimers() {
      for (var reason in this._resumeTimers) clearTimeout(this._resumeTimers[reason]);
      this._resumeTimers = {};
    }

    // Touch is left entirely to the native scroller — we only stop gliding out
    // of its way. Mouse gets a hand-written drag because a native scroll
    // container with a hidden scrollbar has no drag affordance at all.
    _onPointerDown(e) {
      this._hold('pointer');
      clearTimeout(this._resumeTimers.pointer);
      if (!e.pointerId && e.pointerId !== 0) return; // touchstart fallback path
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      this._drag = { x: e.clientX, start: this.track.scrollLeft, moved: 0 };
      this.track.classList.add('is-dragging');
      if (this.track.setPointerCapture) {
        try {
          this.track.setPointerCapture(e.pointerId);
        } catch (err) {
          /* pointer already released */
        }
      }
    }

    _onPointerMove(e) {
      if (!this._drag) return;
      var dx = e.clientX - this._drag.x;
      var travelled = Math.abs(dx);
      if (travelled > this._drag.moved) this._drag.moved = travelled;
      this._handOverToUser();
      this.track.scrollLeft = this._drag.start - dx;
      this._applied = this.track.scrollLeft;
      e.preventDefault();
    }

    _onPointerUp() {
      if (this._drag) {
        // A drag that ends on a card must not also open Instagram. click fires
        // in the same task as pointerup, before this timeout, so the flag is
        // still set when _onClickCapture sees it and gone by the next click.
        if (this._drag.moved > WREELS_DRAG_SLOP) {
          this._suppressClick = true;
          setTimeout(() => {
            this._suppressClick = false;
          }, 0);
        }
        this._drag = null;
        this.track.classList.remove('is-dragging');
      }
      this._scheduleResume('pointer');
    }

    _onClickCapture(e) {
      if (!this._suppressClick) return;
      e.preventDefault();
      e.stopPropagation();
      this._suppressClick = false;
    }

    _onToggle() {
      var paused = this._holds.has('user');
      if (paused) this._release('user');
      else this._hold('user');
      var nowPaused = !paused;
      this.toggleBtn.setAttribute('aria-pressed', nowPaused ? 'true' : 'false');
      if (this.toggleLabel) {
        this.toggleLabel.textContent = nowPaused
          ? this.toggleBtn.dataset.labelPlay || 'Play'
          : this.toggleBtn.dataset.labelPause || 'Pause';
      }
    }

    // Theme editor: selecting a Reel block should bring it into view and hold
    // the strip still while Matthew works on it.
    _onBlockSelect(e) {
      if (!this.contains(e.target)) return;
      this._hold('editor');
      if (e.target.scrollIntoView) {
        e.target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    _onBlockDeselect(e) {
      if (!this.contains(e.target)) return;
      this._release('editor');
    }

    /* ------------------------------------------------------------------ */
    /* Video hydration + playback                                          */
    /* ------------------------------------------------------------------ */

    _observeCards() {
      if (!this._cardObserver) return;
      this._lastWidth = this.track.clientWidth;
      var cards = this._cards();
      for (var i = 0; i < cards.length; i++) {
        cards[i]._wrIn = false;
        cards[i]._wrRatio = 0;
        this._cardObserver.observe(cards[i]);
      }
    }

    _onCardIntersect(entries) {
      for (var i = 0; i < entries.length; i++) {
        entries[i].target._wrIn = entries[i].isIntersecting;
        entries[i].target._wrRatio = entries[i].intersectionRatio;
      }
      this._queueSync();
    }

    _queueSync() {
      if (this._syncQueued) return;
      this._syncQueued = true;
      requestAnimationFrame(() => {
        this._syncQueued = false;
        this._syncPlayback();
      });
    }

    _syncPlayback() {
      if (!this.isConnected) return;
      var cards = this._cards();
      var trackRect = this.track.getBoundingClientRect();
      var centre = trackRect.left + trackRect.width / 2;

      // Everything meaningfully on screen is a candidate; the ones nearest the
      // middle of the screen win the limited play slots.
      var candidates = [];
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        if (card._wrIn && card._wrRatio >= 0.6 && card.querySelector('[data-wreels-video]')) {
          var rect = card.getBoundingClientRect();
          card._wrDist = Math.abs(rect.left + rect.width / 2 - centre);
          candidates.push(card);
        }
      }
      candidates.sort(function (a, b) {
        return a._wrDist - b._wrDist;
      });

      var playing = new Set();
      if (this.allowPlayback) {
        for (var j = 0; j < candidates.length && j < this._maxPlaying; j++) playing.add(candidates[j]);
      }

      for (var k = 0; k < cards.length; k++) {
        var c = cards[k];
        var video = c.querySelector('[data-wreels-video]');
        if (!video) continue;

        if (!c._wrIn) {
          // Far enough away to be worth the memory: drop the src and load() so
          // the decoder and any buffered bytes are actually released.
          this._teardownVideo(c, video);
          continue;
        }

        if (playing.has(c)) {
          this._hydrate(video);
          var promise = video.play();
          if (promise && promise.catch) promise.catch(function () {});
        } else if (!video.paused) {
          video.pause();
        }
      }
    }

    _hydrate(video) {
      if (video.dataset.wrLoaded === '1') return;
      // Setting .muted in JS as well as the attribute: the attribute only sets
      // defaultMuted, and cloneNode-ed elements have been seen to come back
      // unmuted in older WebKit — an unmuted video is a video iOS will not
      // autoplay, which is the whole feature gone.
      video.muted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      video.loop = true;
      video.src = video.dataset.src;
      video.dataset.wrLoaded = '1';
    }

    _teardownVideo(card, video) {
      if (!video.paused) video.pause();
      if (video.dataset.wrLoaded !== '1') return;
      video.removeAttribute('src');
      video.dataset.wrLoaded = '';
      try {
        video.load();
      } catch (err) {
        /* Safari can throw on load() during teardown; nothing to do about it */
      }
      card.classList.remove('is-playing');
    }

    _teardownAllVideos() {
      if (!this.track) return;
      var cards = this._cards();
      for (var i = 0; i < cards.length; i++) {
        var video = cards[i].querySelector('[data-wreels-video]');
        if (video) this._teardownVideo(cards[i], video);
      }
    }

    _onMediaPlaying(e) {
      var card = e.target.closest('.wreels__card');
      if (card) card.classList.add('is-playing');
    }

    _onMediaStopped(e) {
      var card = e.target.closest('.wreels__card');
      if (card) card.classList.remove('is-playing');
    }
  }

  if (!customElements.get('wigglitz-reels')) {
    customElements.define('wigglitz-reels', WigglitzReels);
  }

  } catch(e) { console.error(e); }
})();
})();
